<template>
  <span v-if="node.kind === 'value' && node.ref" class="agent-effect__value">{{ $t("agent_operations.ref", { id: node.text }) }}</span>
  <span v-else-if="node.kind === 'value'" class="agent-effect__value">{{ node.text }}</span>
  <span v-else-if="node.kind === 'money'" class="agent-effect__money font-weight-medium">{{ node.text }}</span>
  <img v-else-if="node.kind === 'image'" :src="node.src" alt="" class="agent-effect__image" data-testid="agent-effect-image" />
  <!-- изменение: прежнее значение серым, новое — обычным текстом; пустое прежнее не выводим -->
  <span v-else-if="node.kind === 'diff'" class="agent-effect__diff" data-testid="agent-effect-diff">
    <template v-if="!isEmpty(node.from)">
      <span class="agent-effect__from text--secondary"><agent-operation-effect :node="node.from" /></span>
      <!-- неразрывный пробел держит стрелку при старом значении, обычный — даёт перенос перед новым -->
      <span class="text--disabled" aria-hidden="true">&nbsp;→ </span>
    </template>
    <agent-operation-effect :node="node.to" />
  </span>
  <ol v-else-if="node.kind === 'list'" class="agent-effect__list">
    <li v-for="(child, index) in node.items" :key="index">
      <agent-operation-effect :node="child" />
    </li>
  </ol>
  <dl v-else class="agent-effect__fields">
    <template v-for="field in node.fields">
      <dt :key="`k-${field.key}`" class="agent-effect__label text--secondary">{{ field.label }}</dt>
      <dd :key="`v-${field.key}`" class="agent-effect__field-value">
        <agent-operation-effect :node="field" />
      </dd>
    </template>
  </dl>
</template>

<script>
// FT-184 REQ-16: рекурсивный вывод узла итога операции агента. Дерево строит
// effectNode (agentOperationEffect.js), здесь только разметка.
export default {
  name: "AgentOperationEffect",
  props: {
    node: { type: Object, required: true },
  },
  methods: {
    // поле было пустым: «— →» — шум, достаточно нового значения
    isEmpty(node) {
      return node.kind === "value" && node.text === "—";
    },
  },
};
</script>

<style scoped>
.agent-effect__list {
  margin: 0;
  padding-left: 1.25em;
}
/* minmax(0, 1fr), а не 1fr: у 1fr нижняя граница — min-content содержимого, и
   картинка подписи или длинный хэш распирали колонку шире экрана телефона
   (стенд CHK-07, 375 px: горизонтальная прокрутка, край подписи обрезан).
   fit-content(50%), а не max-content: во вложенном блоке длинная подпись («Кредитный лимит по периодическим
   платежам», итог объединения клиентов FT-212) забирала всю ширину, и значения шли по букве в строке. */
.agent-effect__fields {
  display: grid;
  grid-template-columns: fit-content(50%) minmax(0, 1fr);
  column-gap: 12px;
  row-gap: 2px;
  margin: 0;
}
/* Подпись на прозрачном фоне: белая подложка, чтобы штрихи читались и в тёмной теме. */
.agent-effect__image {
  display: block;
  /* 240px на широком экране; на узком — не шире своей колонки, пропорции сохраняются. */
  max-width: 100%;
  max-width: min(240px, 100%);
  height: auto;
  max-height: 120px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
.agent-effect__field-value {
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
}
/* Подпись в узком вложенном блоке (телефон, карточка Ren) переносится по слогам: иначе самое длинное слово
   подписи задаёт минимум колонки и значениям не остаётся места. container-type не годится — он обнуляет вклад
   содержимого в ширину ячейки таблицы, и колонка итога сжимается до минимума. */
.agent-effect__label {
  overflow-wrap: anywhere;
  hyphens: auto;
}
</style>
